import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ChevronLeft, Calendar, MapPin } from 'lucide-react';
import { api } from '../lib/api';
import BottomNav from '../components/BottomNav';
import UserAvatar from '../components/UserAvatar';

export default function ContestsDirectoryPage() {
  const nav = useNavigate();
  const [cities, setCities] = useState([]);
  const [contests, setContests] = useState([]);
  const [city, setCity] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get('/contests/cities/directory');
        setCities(data.items || []);
      } catch {}
      finally { setLoading(false); }
    })();
  }, []);

  const loadCity = async (c) => {
    setCity(c);
    setLoading(true);
    try {
      const { data } = await api.get('/contests', { params: { city: c.city, country: c.country, limit: 30 } });
      setContests(data.items || []);
    } catch {}
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-aura-bg pb-28 relative">
      <div className="absolute inset-0 bg-aura-radial pointer-events-none" />
      <header className="relative flex items-center justify-between px-5 pt-6">
        <button onClick={() => city ? setCity(null) : nav(-1)} className="text-aura-textDim flex items-center gap-1"><ChevronLeft size={20} /></button>
        <div className="font-display font-black tracking-[0.3em] aura-text-gradient text-sm">CONTIENDAS</div>
        <span className="w-8" />
      </header>

      <main className="relative mx-auto max-w-md px-5 pt-4 space-y-3">
        {loading ? (
          <div className="text-center py-16 text-aura-textDim animate-aura-pulse text-4xl">⚡</div>
        ) : !city ? (
          <>
            <h3 className="text-xs font-display font-bold text-white tracking-widest mb-2">Ciudades con contiendas activas</h3>
            {cities.length === 0 ? (
              <div className="aura-card p-8 text-center text-sm text-aura-textDim">Sin contiendas programadas todavía.</div>
            ) : cities.map((c) => (
              <button key={`${c.city}-${c.country}`} onClick={() => loadCity(c)} data-testid={`city-${c.city}`} className="w-full aura-card p-4 flex items-center justify-between hover:border-aura-cyan/40 transition text-left">
                <div>
                  <div className="font-display font-bold text-white">{c.city}</div>
                  <div className="text-xs text-aura-textDim">{c.country}</div>
                </div>
                <div className="text-right">
                  <div className="font-mono font-bold text-aura-cyan text-lg">{c.count}</div>
                  <div className="text-[9px] uppercase tracking-widest text-aura-textDim">contiendas</div>
                </div>
              </button>
            ))}
          </>
        ) : (
          <>
            <div className="text-center mb-4">
              <div className="font-display font-black text-2xl aura-text-gradient">{city.city}</div>
              <div className="text-xs text-aura-textDim">{contests.length} contiendas · {city.country}</div>
            </div>
            {contests.map((c) => (
              <Link key={c.contest_id} to={`/u/${c.host?.username}`} className="block aura-card p-4">
                <div className="flex items-center gap-3 mb-2">
                  <UserAvatar user={c.host} size="sm" />
                  <div>
                    <div className="font-display font-bold text-white text-sm">{c.title}</div>
                    <div className="text-xs text-aura-textDim">por @{c.host?.username}</div>
                  </div>
                </div>
                {c.description && <p className="text-sm text-white/85 mb-2">{c.description}</p>}
                <div className="text-xs text-aura-textDim flex items-center gap-1 mb-1"><Calendar size={11} />{new Date(c.event_datetime).toLocaleString('es-MX', { dateStyle: 'medium', timeStyle: 'short' })}</div>
                <div className="text-xs text-aura-textDim flex items-center gap-1"><MapPin size={11} />{[c.venue_name, c.address].filter(Boolean).join(' · ')}</div>
                {c.latitude != null && c.longitude != null && (
                  <iframe title="map" src={c.maps_embed} className="w-full h-40 rounded-lg mt-2 border border-white/10" loading="lazy" />
                )}
                <a href={c.maps_url} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()} className="mt-2 inline-block text-xs text-aura-cyan">Abrir en Google Maps →</a>
              </Link>
            ))}
          </>
        )}
      </main>
      <BottomNav />
    </div>
  );
}
